export default __webpack_public_path__ + "static/media/IMG_3650.5b507c31.png";